
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Logo extends Vue {
  @Prop({ default: "32" })
  size!: string;

  @Prop({ default: "#ffffff" })
  fill!: string;
}
